import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "doc-sort__list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "doc-sort__title" }

import { onBeforeMount, ref, useTemplateRef } from 'vue'

import type { DocsView } from '@/models/doc'
import { DocsSortMobileView as DocsSortView } from '@/models/docs.sort'
import { emitter } from '@/services/mitt'

import BasePopup from '@/components/ui/BasePopup.vue'
import AppButton from '@/app/components/button/AppButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DocsSort.mobile',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const popup = useTemplateRef('popup')
const sortView = ref(new DocsSortView(props.view, hide))

onBeforeMount(async () => {
  emitter.on('openSortPopup', () => {
    popup.value?.show()
  })
})

function hide(): void {
  popup.value?.hide()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasePopup, {
    ref_key: "popup",
    ref: popup,
    class: "doc-sort"
  }, {
    buttons: _withCtx(() => [
      _createVNode(AppButton, {
        class: "doc-sort__btn",
        big: true,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (sortView.value.applySort()))
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Apply ", -1)
        ]))]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortView.value.options, (opt) => {
          return (_openBlock(), _createElementBlock("li", {
            key: opt.name,
            class: _normalizeClass(["doc-sort__item", sortView.value.activeOptionClass(opt)]),
            onClick: ($event: any) => (sortView.value.optionClick(opt))
          }, [
            _createElementVNode("span", _hoisted_3, [
              _createElementVNode("span", {
                class: _normalizeClass(["doc-sort__icon iconfont", opt.icon])
              }, null, 2),
              _createTextVNode(_toDisplayString(opt.name), 1)
            ])
          ], 10, _hoisted_2))
        }), 128))
      ])
    ]),
    _: 1
  }, 512))
}
}

})